import React from 'react';

const QuickActions = () => {
  const actions = ['Add Event', 'Add User', 'View Messages', 'View Reviews'];

  return (
    <div className="quick-actions">
      <h3>Quick Actions</h3>

      <div className="quick-grid">
        {actions.map((action) => (
          <button key={action}>{action}</button>
        ))}
      </div>
    </div>
  );
};

export default QuickActions;